module.exports = __webpack_public_path__ + "images/rich_heading/other/bg_468c1e746068f1bbafbe5ebfe2d625d0.png";